import React from 'react';
import { useState,useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav'
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import './grievance.css'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 


const Grievance = () => {
    const tableRef = useRef(null);

    const data=[
        {id:"1", list:"Kohinoor Apartmnets", buy:"Cassie F",sell:"Robert G", escrow: "29/10/22", approve: "pending"},
        {id:"2", list:"Kohinoor Apartmnets", buy:"Kate B",sell:"Henry B",  escrow: "29/10/22", approve: "pending"},
        ]
        
    const columns = [
        { field: "id", headerName: " ", width: 20 },
        
        {field: "action", headerName: "Receipt",width: 200,
        renderCell: (params) => {return (
                <>
                <button className="widgetLgButton">View Receipt</button>
                </>);},},

        {field: "issue", headerName: "Issue",width: 200,
        renderCell: (params) => {return (
               <>
                <button className="widgetLgButton">View Complaint</button>
               </>);},},
                
        { field: "list", headerName: "Property Listing", width: 200 },
        { field: "buy",headerName: "Buyer Details",width: 200,},
        { field: "sell",headerName: "Seller Details",width: 200,},
        { field: "escrow", headerName: "Date of Escrow", width: 200 },
        { field: "approve", headerName: "Date of Approval", width: 200 },

        ];


    async function  toastAdd(){
        toast.success('Check in "Orders" .')
        toast.success('Please wait for agent to verify purchase.')
    }

  return (
    <div>
        <Nav/>
        <div className="orderTitle"><GridViewRoundedIcon/>Grievances List</div>
        <div style={{"height":"50vh"}} className='GrievanceTable1'>
         <DataGrid
            rows={data}
            columns={columns}
            pageSize={8}
            checkboxSelection
            ref={tableRef}
            sx={{
                p:0
              }}
         />
         </div>
         <div className="orderTitle"><GridViewRoundedIcon/>Grievance Form</div>
         <div className="GrievanceForm">
            <div className="grievance1">
              <div className="FormTitle" id="title" >Your Name </div>
              <input type="text" name="gate" id="apart" style={{"width":"26vw","height":"5vh","border":"1px solid grey","marginLeft":"1%"}}/>
            </div>
            <div className="grievance1">
              <div className="FormTitle" id="title" >Seller Name </div>
              <input type="text" name="gate" id="apart" style={{"width":"26vw","height":"5vh","border":"1px solid grey","marginLeft":"1%"}}/>
            </div>
            <div className="grievance1">
              <div className="FormTitle" id="title" >Issue </div>
              <textarea  style={{"width":"26vw","height":"10vh","border":"1px solid grey","marginLeft":"1%"}}></textarea>
            </div>
            <div className="grievance1">
              <div className="FormTitle" id="title" >Receipt </div>
              <input type="file" style={{"marginLeft":"1%"}}></input>
            </div>
            <br/><br/><br/><br/>
            <button className="SubmitFormButton" onClick={toastAdd} style={{"width":"50%","marginLeft":"2%"}}>Submit</button>
            <br/><br/><br/><br/>
         </div>
    </div>
  )
}

export default Grievance